import amongTheFish from '../../images/photography/Among the Fish.jpg';
import balboaPier from '../../images/photography/Balboa Pier in July.jpg';
import boatsInSDBay from '../../images/photography/Boats in San Diego Bay.jpg';
import boatsOnNEmbarcadero from '../../images/photography/Boats on North Embarcadero.jpg';
import calvaryBaptist from '../../images/photography/Calvary Baptist Church.jpg';
import santaMonica from '../../images/photography/Gloom in Santa Monica.jpg';
import goldenGate from '../../images/photography/Golden Gate Bridge.jpg';
import intoTheFog from '../../images/photography/Into the Fog.jpg';
import number9 from '../../images/photography/No 9 Fishermens Grotto.jpg';
import quietMorning from '../../images/photography/Quiet Morning.jpg';
import rowboat from '../../images/photography/Rowboat to Nowhere.jpg';
import surfers from '../../images/photography/Surfers at Dusk.jpg';
import windanseaI from '../../images/photography/Windansea Sunset I.jpg';
import windanseaII from '../../images/photography/Windansea Sunset II.jpg';

export const gallery = [
  santaMonica, amongTheFish, intoTheFog, rowboat, surfers, balboaPier,
  boatsInSDBay,boatsOnNEmbarcadero,calvaryBaptist, goldenGate, number9,
  quietMorning, windanseaI, windanseaII
]
  
export const galleryInfo = [
    {
        image: santaMonica,
        title: 'Gloom in Santa Monica',
        location: 'Santa Monica, CA',
        date: '2020',
        link: 'https://society6.com/product/gloom-in-santa-monica_print',
        alt: 'alt text'
    },
    {
      image: amongTheFish,
      title: 'Among the Fish',
      location: 'Monterey, CA',
      date: '2020',
      link: 'https://society6.com/product/among-the-fish_print',
      alt: 'alt text'
    },
    {
        image: intoTheFog,
        title: 'Into the Fog',
        location: '2020',
        date: 'Newport Beach, CA',
        link: 'https://society6.com/product/into-the-fog5400173_print',
        alt: 'alt text'
    },
    {
        image: rowboat,
        title: 'Rowboat to Nowhere',
        location: 'San Diego, CA',
        date: '2020',
        link: 'https://society6.com/product/rowboat-to-nowhere_print',
        alt: 'alt text'
    },
    {
        image: surfers,
        title: 'Surfers at Dusk',
        location: 'La Jolla, CA',
        date: '2020',
        link: 'https://society6.com/product/surfers-at-dusk_print',
        alt: 'alt text'
    },
    {
      image: balboaPier,
      title: 'Balboa Pier in July',
      location: 'Newport Beach, CA',
      date: '2020',
      link: 'https://society6.com/product/balboa-pier-in-july5392394_print',
      alt: 'alt text'
    },
    {
      image: boatsInSDBay,
      title: 'Boats in San Diego Bay',
      location: 'San Diego, CA',
      date: '2021',
      link: 'https://society6.com/product/boats-in-san-diego-bay_print',
      alt: 'alt text'
    },
    {
      image: boatsOnNEmbarcadero,
      title: 'Boats on North Embarcadero',
      location: 'San Diego, CA',
      date: '2021',
      link: 'https://society6.com/product/boats-on-north-embarcadero_print',
      alt: 'alt text'
    },
    {
      image: calvaryBaptist,
      title: 'Calvary Baptist Church',
      location: 'San Diego, CA',
      date: '2021',
      link: 'https://society6.com/product/pink-calvary-baptist-church_print',
      alt: 'alt text'
    },
    {
      image: goldenGate,
      title: 'Golden Gate Bridge',
      location: 'San Francisco, CA',
      date: '2020',
      link: 'https://society6.com/product/golden-gate-bridge8675148_print',
      alt: 'alt text'
    },
    {
      image: number9,
      title: "No. 9 Fishermen's Grotto",
      location: 'San Francisco, CA',
      date: '2020',
      link: 'https://society6.com/product/no-9-fishermens-grotto_print',
      alt: 'alt text'
    },
    {
      image: quietMorning,
      title: 'Quiet Morning',
      location: 'Twin Peaks, CA',
      date: '2020',
      link: 'https://society6.com/product/quiet-morning5400222_print',
      alt: 'alt text'
    },
    {
      image: windanseaI,
      title: 'Windansea Sunset I',
      location: 'La Jolla, CA',
      date: '2020',
      link: 'https://society6.com/product/windansea-sunset-i_print',
      alt: 'alt text'
    },
    {
      image: windanseaII,
      title: 'Windansea Sunset II',
      location: 'La Jolla, CA',
      date: '2020',
      link: 'https://society6.com/product/windansea-sunset-ii_print',
      alt: 'alt text'
    },
];

/*
Not importing aldrichHall; doesn't fit in gallery (vertical)
{
    image: aldrichHall,
    link: "https://society6.com/product/aldrich-hall-at-sunset_print",
    alt: "UCI's Aldrich Hall peeks out from behind a building, illuminated by the sun"
}
*/